import React from 'react';
import Footer from './common/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-900 relative overflow-hidden">
   

      <div className="flex-grow flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <div className="w-full max-w-lg mb-8">
          <div className="flex flex-col items-center relative z-10">
            <img
              src="/images/imr-logo.png"
              alt="IMR Logo"
              className="h-32 w-auto mb-4"
            />
            <h1 className="text-center text-2xl font-bold text-yellow-500">
              DEFENCE INDUSTRY DIRECTORY
            </h1>
          </div>
        </div>

        {/* Privacy Policy Content */}
        <div className="w-full max-w-4xl relative z-10">
          <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm text-gray-300">
            <h2 className="text-2xl font-bold text-yellow-500 mb-6">Privacy Policy</h2>
            <p className="text-sm mb-4">Effective Date: 1 June 2025</p>
            
            <p className="mb-6">
              This Privacy Policy describes how directory.defencepartners.in ("we," "us," or "our") collects, uses, 
              discloses, and protects your personal information when you use our website and subscription services.
            </p>

            <div className="space-y-6">
              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">1. Information We Collect</h3>
                <p className="mb-4">We may collect and process the following types of personal information:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Name, email address, and contact details</li>
                  <li>Company name, business information, products/ services</li>
                  <li>Subscription and payment information</li>
                  <li>Usage data, such as IP address, browser type, device information, and pages visited</li>
                  <li>Any information you provide through forms or correspondence</li>
                </ul>
                <p className="mt-4">We may also use cookies and similar technologies to collect data about your interactions with our website.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">2. How We Use Your Information</h3>
                <p className="mb-4">We use your information to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Provide and manage your subscription and access to our services</li>
                  <li>Process payments and manage billing</li>
                  <li>Respond to your inquiries and provide customer support</li>
                  <li>Improve our website, services, and user experience</li>
                  <li>Communicate important updates, newsletters, or marketing (your consent is implied)</li>
                  <li>Comply with legal obligations and enforce our Terms of Use</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">3. Sharing and Disclosure</h3>
                <p className="mb-4">We may share your personal information with:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Payment processors and service providers who assist in delivering our services</li>
                  <li>Legal authorities if required by law or to protect our rights</li>
                  <li>Third parties only as necessary to fulfill the services or with your explicit consent</li>
                </ul>
                <p className="mt-4">We do not sell your personal information to third parties.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">4. Data Security</h3>
                <p>We implement appropriate technical and organizational measures to protect your data, including encryption, secure servers, and restricted access. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">5. Data Retention</h3>
                <p>We retain your personal data only as long as necessary to provide our services, fulfill legal obligations, resolve disputes, and enforce our agreements. When your information is no longer needed, we will securely delete or anonymize it.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">6. Your Rights</h3>
                <p className="mb-4">Depending on your jurisdiction, you may have the right to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Access, update, or delete your personal information</li>
                  <li>Withdraw consent or object to certain uses of your data</li>
                </ul>
                <p className="mt-4">To exercise these rights, please contact us at the email provided below. We will respond to your request in accordance with applicable laws.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">7. Cookies and Tracking Technologies</h3>
                <p>We use cookies and similar technologies to enhance your experience, analyze website usage, and deliver relevant content. You can manage your cookie preferences through your browser settings. For more details, see our Cookie Policy.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">8. Third-Party Links</h3>
                <p>Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of those sites. Please review their privacy policies before providing personal information.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">9. Changes to This Policy</h3>
                <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. We encourage you to review this Policy regularly.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-yellow-500 mb-2">10. Contact Us</h3>
                <p>If you have any questions or concerns about this Privacy Policy or your personal information, please contact us at directory@defencepartners.in</p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
